import type { EventName } from "@lit/react";
import { MasterDetailLayout as MasterDetailLayoutElement, type MasterDetailLayoutEventMap as _MasterDetailLayoutEventMap, } from "@vaadin/master-detail-layout/vaadin-master-detail-layout.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { MasterDetailLayoutElement, };
export type MasterDetailLayoutEventMap = Readonly<{
    onBackdropClick: EventName<_MasterDetailLayoutEventMap["backdrop-click"]>;
    onDetailEscapePress: EventName<_MasterDetailLayoutEventMap["detail-escape-press"]>;
}>;
const events = { onBackdropClick: "backdrop-click", onDetailEscapePress: "detail-escape-press" } as MasterDetailLayoutEventMap;
export type MasterDetailLayoutProps = WebComponentProps<MasterDetailLayoutElement, MasterDetailLayoutEventMap>;
export const MasterDetailLayout = createComponent({
    elementClass: MasterDetailLayoutElement, events, react: React, tagName: "vaadin-master-detail-layout"
});
